import React, { Fragment } from 'react';

import ManagedMedicationsTable from './managed-medications-table';
import MedicationFormulariesHeader from '../medication-formularies-header';

import '../styles.scss';

const MedicationFormulariesSearch = () => (
  <Fragment>
    <MedicationFormulariesHeader />
    <ManagedMedicationsTable />
  </Fragment>
);

export default MedicationFormulariesSearch;
